module.exports = "/images/vendor/flag-icon-css/flags/1x1/lk.svg?f54e1ef96c3b7670cd8de1ffdaa7f085";